import React, { useState, useContext, useEffect } from 'react'
import { useIntl } from 'react-intl'
import MainContext from '@/stores/stores'
import styles from './index.module.scss'

type CurrencyExrateProps = {
  money: number,
  style?: React.CSSProperties;
}
const CurrencyExrate: React.FC<CurrencyExrateProps> = (props) => {
  const intl = useIntl()
  const { money = 0, style={} } = props
  const { commonStore, setCommonStore } = useContext(MainContext)
  const [unit, setUnit] = useState<string>('')
  const [exchangeMomey, setExchangeMoney] = useState<number>(0)
  useEffect(() => {
    if(commonStore.countrie_data) {
      if(commonStore.countrie_data.unit) {
        setUnit(commonStore.countrie_data.unit)
      }else if(commonStore.countrie_data.code) {
        let _unit = commonStore.countrie_data.code + '  '
        setUnit(_unit)
      }
    }
  }, [commonStore.countrie_data])
  useEffect(() => {
    if(commonStore.exrate) {
      let _exchangeMomey = money * commonStore.exrate
      _exchangeMomey = Math.round(_exchangeMomey * 100) / 100;
      setExchangeMoney(_exchangeMomey)
    }
  }, [commonStore.exrate, money])
  return (
    <>
      {
        commonStore.currency_data && commonStore.currency_data.code && commonStore.countrie_data && commonStore.countrie_data.code && commonStore.currency_data.code !== commonStore.countrie_data.code ? <div className={styles['exrate-wrap']} style={style}>
          {intl.formatMessage({id: '约{unit}{money}'}, {unit: unit, money: exchangeMomey})}
        </div> : null
      }
    </>
    
  )
}
export default CurrencyExrate